import React from "react";
import { Card, CardBody } from "reactstrap";
import Shimmer from "./Shimmer";


interface CardShimmerProps{
profile?:boolean
}

const CardShimmer: React.FC<CardShimmerProps> = ({profile= false}) => {
  return (
    <Card className="text-center p-2 rounded-3 shadow-sm" style={{ minWidth: "265px", height: "260px", width: "100%" }}>
      <CardBody>
        {
            profile?(
            <div style={{marginLeft:'50px'}}>
            <Shimmer width="80px" height="80px"borderRadius="50%"className="mb-4"/>  
            <Shimmer width="70%" height="16px" borderRadius="6px" className="mb-3"/>
            <Shimmer width="90%" height="14px" borderRadius="6px"className="mb-3"/>
            <Shimmer width="60%" height="14px" borderRadius="6px" />

            </div>
  
            ):(
            <>
        <Shimmer width="100%" height="14px" borderRadius="6px" className="mb-3" />
        <Shimmer width="100%" height="14px" borderRadius="6px" className="mb-3" />
        <Shimmer width="100%" height="14px" borderRadius="6px" className="mb-3" />
        <Shimmer width="100%" height="14px" borderRadius="6px" className="mb-3" />
        <Shimmer width="100%" height="14px" borderRadius="6px" className="mb-3" />
        <Shimmer width="100%" height="14px" borderRadius="6px" />
        </>
            )
        }
        
      </CardBody>

    </Card>
  );
};

export default CardShimmer;
